<div class="container">

  <app-header-dialog [iconName]="'mail_outline'">
    Pagamento Anuidades 
  </app-header-dialog>

  <div class='content'>

    <div class="data-wrapper">
      <div class="data-text">
        Tid: {{order.Tid}}
      </div>
      <div class="data-text" *ngIf="!order.datePayed">
        Data: {{order.date._seconds*1000 | date: 'dd/MM/yyyy'}}
      </div>
      <div class="data-text" *ngIf="order.datePayed">
        Data: {{order.datePayed | date: 'dd/MM/yyyy'}}
      </div>

      <div class="data-text">
        Origin: {{order.origin}}
      </div>
      <div class="data-text">
        Tipo: {{order.payment_type}}
      </div>

    </div>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="value" appearance="outline">
        <mat-label>Original</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.rawValue"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.rawValue.hasError('required')">
          O Valor Original é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="value" appearance="outline">
        <mat-label>Desconto</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.discount"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.discount.hasError('required')">
          O Desconto é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="value" appearance="outline">
        <mat-label>Valor</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.value"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.value.hasError('required')">
          O Valor é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="value" appearance="outline">
        <mat-label>Total</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.total"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.total.hasError('required')">
          O Total é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="value" appearance="outline">
        <mat-label>Líquido</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.total_minus_tax"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.total_minus_tax.hasError('required')">
          O Valor Líquido é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button matTooltip='ok' mat-raised-button (click)="matDialogRef.close([ 'edit', entityForm ])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>